import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('reports-blueprints', storeModule.createStoreModule('reports-blueprints'))
